import { ChangeDetectionStrategy, Component, Sanitizer, input, inject, computed } from '@angular/core';
import {SlicePipe} from "@angular/common";
import {UISize} from "../../base/types";

@Component({
  selector: 'ui-avatar',
  imports: [
    SlicePipe
  ],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.size-xs]': 'isSizeXs',
    '[class.size-m]': `size() === 'medium'` ,
    '[class.size-l]': `size() === 'large'` ,
    '[style.background-image]': 'background()'
  }
})
export class AvatarComponent {
  private san = inject(Sanitizer);

  readonly avatar = input('');
  readonly name = input('');
  readonly size = input<UISize>('small');

  protected get isSizeXs() {
    return this.size() === 'xs';
  }
  protected readonly background = computed(() => this.avatar() ? `url(${this.avatar()})` : null);
}
